import { HighImpactTroubleshootingSteps } from './HighImpactTroubleshootingSteps.tsx'

export const HighImpactAlert9Troubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of Impact Alert Level 9 issues, please follow these steps:
        </h4>

        <HighImpactTroubleshootingSteps/>
    </div>
